
import store from '@sl/base/store';
export class Payline {
    constructor(scene) {
        this.scene = scene;
        this.paylinesContainer = this.scene.add.container();
        this.paylines = {};
        this.paylinesHideDelay = 1500;
        this.singlePaylineHideDelay = 800;
        this.hideEvent = null;
    }

    showPayline(payline, showChosen) {
        let paylineOnReels = this.scene.slots.reelsContainer.getByName(`payline_${payline}`);
        this.scene.slots.reelsContainer.bringToTop(paylineOnReels);


        if(showChosen || ! this.paylines[payline].particleConfig) {
            this.paylines[payline].alpha = 1;

            if(showChosen && payline < store.getters.currentPayline) { 
                this.paylines[payline].alpha = 0.3;
            }
        }

        if(paylineOnReels.particleConfig && !showChosen) {
            this.scene.slots.reelsContainer.bringToTop(paylineOnReels.particle);
            this.paylines[payline].emitter = this.paylines[payline].particle.createEmitter(this.paylines[payline].particleConfig);
            this.paylines[payline].emitter.start();
    
            setTimeout(() => {
                this.paylines[payline].emitter.stop();
                this.paylines[payline].emitter = null;
            }, this.singlePaylineHideDelay);
        }
    }

    hidePayline(payline) {
        this.paylines[payline].alpha = 0;
    }

    hidePaylines() {
        if(this.hideEvent) {
            this.hideEvent.destroy();
        }

        for(const [ paylineIndex, payline ] of Object.entries(this.paylines)) {
            this.hidePayline(paylineIndex);
        }
    }
    
    showChosenPaylines() {
        if (Config.settings.hide_chosen_paylines) {
            return;
        }

        this.hidePaylines();

        for(const [ paylineIndex, payline ] of Object.entries(this.paylines)) {
            if(paylineIndex <= store.getters.currentPayline) {
                this.showPayline(paylineIndex, true);
            }
        }

        this.hideEvent = this.scene.time.delayedCall(this.paylinesHideDelay, this.hidePaylines, {}, this);
    }

    drawPaylines() {
        if (typeof this.scene.drawPaylines === 'function') {  
            this.scene.drawPaylines();
            return;
        }

        for(const [ paylineIndex, payline ] of Object.entries(Config.paylines)) {
            let points = [];

            for(const [ reelIndex, rowIndex ] of Object.entries(payline)) {
                let symbol = this.scene.slots.reelsContainersObjects[reelIndex].symbols[rowIndex];
                let y = symbol.y;

                if(symbol.sizeOnReel > 1) {
                    y = (y - (symbol.height / 2)) + this.scene.slots.symbolHeight / 2
                }

                points.push({
                    "x":this.scene.slots.reelsContainersObjects[reelIndex].x, 
                    "y":y,
                    "x_absolute":this.scene.slots.reelsContainersObjects[reelIndex].x + this.scene.slots.frame.width / 2, 
                    "y_absolute":(y - this.scene.slots.reelsOffsetTop) + this.scene.slots.frame.height / 2,
                });
            }

            var texture = this.scene.textures.createCanvas('custom_pattern' + paylineIndex, this.scene.slots.frame.width, this.scene.slots.frame.height);
            var ctx = texture.context;
    
            if (typeof this.scene.setPaylineColor === 'function') { 
                ctx = this.scene.setPaylineColor(ctx);
            } else {
                ctx.lineWidth = 5;
                ctx.strokeStyle = "#c8242c";
            }

            let x = points[0].x;
            let x_absolute = points[0].x_absolute;

            if(Config.settings.extendedPaylines) {
                x -= this.scene.slots.symbolWidth / 2;
                x_absolute -= this.scene.slots.symbolWidth / 2;
            }
    
            ctx.moveTo(x_absolute, points[0].y_absolute);

            let path = new Phaser.Curves.Path(x, points[0].y);

            for (let i = 0; i < points.length; i++)
            {
                ctx.lineTo(points[i].x_absolute, points[i].y_absolute);
                path.lineTo(points[i].x, points[i].y);

                if(Config.settings.extendedPaylines && i === points.length-1) {
                    ctx.lineTo(points[i].x_absolute + this.scene.slots.symbolWidth / 2, points[i].y_absolute);
                    path.lineTo(points[i].x + this.scene.slots.symbolWidth / 2, points[i].y);
                }
            }
            
            if (typeof this.scene.setPaylinePattern === 'function') { 
                ctx = this.scene.setPaylinePattern(ctx);
            }

            ctx.stroke();

            let paylineDrawed = this.scene.add.image(0,  this.scene.slots.reelsOffsetTop, 'custom_pattern' + paylineIndex);
            paylineDrawed.alpha =0;
            
            this.paylines[paylineIndex] = paylineDrawed;
            this.paylines[paylineIndex].path = path;
            this.paylines[paylineIndex].name = `payline_${paylineIndex}`;
            this.paylinesContainer.add(this.paylines[paylineIndex]);

            if (typeof this.scene.addPaylineAnimations === 'function') { 
                this.paylines[paylineIndex] = this.scene.addPaylineAnimations(this.paylines[paylineIndex], points);
            }
           
            this.scene.slots.reelsContainer.add(this.paylines[paylineIndex]);
        }
    }
}